import React from 'react';
import {
    Card,
    InputText,
    LoaderBtn,
    Captcha,
} from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { Form, Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import styles from './SetNewPasswordContainer.module.scss';
import cn from 'classnames';

const SetNewPasswordContainer = ({
    checkResetPasswordToken, resetPassword, token, apiError, onPush, clearErrors,
}: Props) => {
    const initErrors: IInitErrors = {
        newPassword: '',
        repeatPassword: '',
    };
    const [captcha, setCaptcha] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [repeatPassword, setRepeatPassword] = React.useState('');
    const [validErrors, setValidErrors] = React.useState(initErrors);
    const [captchaValid, setCaptchaValid] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);
    const captchaError = apiError && apiError.failures && apiError.failures.captcha;
    const tokenError = apiError && apiError.failures && apiError.failures.token;

    React.useEffect(() => {
        const fetch = async () => {
            setLoading(true);
            await checkResetPasswordToken({ token, captcha });
            setLoading(false);
        };

        fetch();
    }, [token]);

    const doValidate = () => {
        const isCaptchaValid = captchaError ? captcha.length === 4 : true;
        const isNewPasswordValid = newPassword.length >= 6;
        const isRepeatPasswordValid = repeatPassword.length > 0 && repeatPassword === newPassword;

        setValidErrors({
            newPassword: isNewPasswordValid ? '' : 'Минимальная длина пароля 6 символов',
            repeatPassword: isRepeatPasswordValid ? '' : 'Пароли не совпадают',
        });
        setCaptchaValid(isCaptchaValid);
        return isCaptchaValid && isNewPasswordValid && isRepeatPasswordValid;
    };

    const onSubmit = async () => {
        if (doValidate()) {
            setProcessing(true);
            const res = await resetPassword({ token, newPassword, captcha });

            if (!res) {
                setProcessing(false);
                setCaptcha('');
            }
        }
    };

    const goBack = () => {
        clearErrors();
        onPush('/');
    };

    return (
        <Col className={cn('auth-forms--container', styles.newPasswordCardContainer)}>
            <Card
              title="Сброс пароля"
              apiError={apiError}
              showLoader={loading}
            >
                {tokenError && (
                    <>
                        <Form.Control.Feedback className="d-block" type="invalid">
                            {apiError && apiError.message}
                        </Form.Control.Feedback>
                        <Button className="mt-4" onClick={goBack}>
                            Назад
                        </Button>
                    </>
                )}

                {!tokenError && (
                    <>
                        <div className="sub-title">
                            Установите новый пароль
                        </div>
                        <InputText
                          name="newPassword"
                          value={newPassword}
                          labelTitle="НОВЫЙ ПАРОЛЬ"
                          labelColSize={4}
                          inputColSize={8}
                          fieldFailures={validErrors}
                          onChange={(name, value) => {
                                setNewPassword(value);
                                setValidErrors({ ...validErrors, [name]: '' });
                            }}
                        />
                        <InputText
                          name="repeatPassword"
                          value={repeatPassword}
                          labelTitle="ПОДТВЕРЖДЕНИЕ"
                          labelColSize={4}
                          inputColSize={8}
                          fieldFailures={validErrors}
                          onChange={(name, value) => {
                                setRepeatPassword(value);
                                setValidErrors({ ...validErrors, [name]: '' });
                            }}
                        />
                        <Captcha captcha={captcha} captchaValid={captchaValid} apiError={apiError} setCaptcha={setCaptcha} />
                        <Form.Control.Feedback className="d-block" type="invalid">
                            {apiError && !apiError.failures && apiError.message}
                        </Form.Control.Feedback>
                        <LoaderBtn
                          className="mt-4"
                          loading={processing}
                          disabled={processing}
                          onClick={onSubmit}
                        >
                            Сохранить
                        </LoaderBtn>
                    </>
                )}
            </Card>
        </Col>
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    clearErrors: dispatch.errors.clean,
    checkResetPasswordToken: dispatch.auth.checkResetPasswordTokenAsync,
    resetPassword: dispatch.auth.resetPasswordAsync,
});

export default connect(mapState, mapDispatch)(SetNewPasswordContainer);

interface IProps {
    token: string;
}

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch> & IProps;

interface IInitErrors {
    newPassword: string;
    repeatPassword: string;
    [key: string]: string;
}
